import {
  FETCH_EXPERTS_REQUEST,
  FETCH_EXPERTS_SUCCESS,
  APPEND_EXPERTS_SUCCESS,
  SET_EXPERTS_PAGE,
  FETCH_HOMEPAGE_EXPERTS_SUCCESS,
  BOOK_SLOT_REQUEST,
  BOOK_SLOT_SUCCESS,
  BOOK_SLOT_FAILURE,
  SET_CURRENT_SESSION_ID
} from './constants';

const initialState = {
  experts: [],
  homepageExperts: [],
  loading: false,
  page: 1,
  total: 0,
  slotsByExpert: {},
  slotsLoading: false,
  slotsMeta: {},
  bookingLoading: false,
  bookingError: null,
  currentSessionId: null,
};

export default function expertsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXPERTS_REQUEST:
      return { ...state, loading: true };
    case FETCH_EXPERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        experts: action.payload.experts,
        total: action.payload.total,
        page: action.payload.page
      };
    case APPEND_EXPERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        experts: [...state.experts, ...action.payload.experts],
        total: action.payload.total,
        page: action.payload.page
      };
    case FETCH_HOMEPAGE_EXPERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        homepageExperts: action.payload
      };
    case SET_EXPERTS_PAGE:
      return { ...state, page: action.page };
    case 'FETCH_EXPERT_SLOTS_REQUEST':
      return { ...state, slotsLoading: true };
    case 'FETCH_EXPERT_SLOTS_SUCCESS':
      return {
        ...state,
        slotsLoading: false,
        slotsByExpert: {
          ...state.slotsByExpert,
          [action.payload.expert_id]: action.payload.slots
        },
        slotsMeta: {
          ...state.slotsMeta,
          [action.payload.expert_id]: action.payload.meta
        }
      };
    case BOOK_SLOT_REQUEST:
      return { ...state, bookingLoading: true, bookingError: null };
    case BOOK_SLOT_SUCCESS:
      return { ...state, bookingLoading: false, bookingError: null };
    case BOOK_SLOT_FAILURE:
      return { ...state, bookingLoading: false, bookingError: action.error };
    case SET_CURRENT_SESSION_ID:
      return { ...state, currentSessionId: action.payload };
    default:
      return state;
  }
} 